<template>
	<div>
		<div class="white-bg pad20 ra4">
			<div class="usertop">
				<img v-if="userlist.avatar.length != 0" :src="userlist.avatar" class="avatar" alt="">
				<img v-else :src="require('@/assets/image/avatar.jpeg')" class="avatar">
				<div v-if="userlist.userName">
					<h2>{{userlist.userName}}</h2>
					<div class="d-gray mt10">作品数：{{userlist.workCount}}</div>
				</div>
			</div>
		</div>
		<div class="white-bg pad20 ra4 mt20 mb20">
			<div class="usercon">
				<div class="usertitle flexween">
					<div class="t">个人资料<span class="d-gray tips">修改你的基本资料，将显示在你的个人名片中，并可以让更多的朋友了解和认识你！</span></div>
					<div class="d-gray editI" @click="eidtUser"><i class="el-icon-edit"></i>编辑</div>
				</div>
				<h3 class="mt20">基本信息</h3>
				<div class="userc" v-if="userlist.userName">
					<span>用户昵称</span>
					<div class="ucd">{{userlist.userName}}</div>
				</div>
				<div class="userc" v-if="userlist.userId">
					<span>用户ID</span>
					<div class="ucd">{{userlist.userId}}</div>
				</div>
				<div class="userc">
					<span>性别</span>
					<div class="ucd">
						<span v-if="userlist.sex==0">男</span>
						<span v-else-if="userlist.sex==1">女</span>
						<span v-else>未选择</span>
					</div>
				</div>
				<div class="userc">
					<span>个人简介</span>
					<div class="ucd">{{userlist.profile|| '未填写'}}</div>
				</div>
				<div class="userc">
					<span>所在地区</span>
					<div class="ucd">{{userlist.region|| '未选择'}}</div>
				</div>
				<div class="userc" v-if="userlist.birthday">
					<span>出生日期</span>
					<div class="ucd">{{$dayjs(userlist.birthday).format('YYYY-MM-DD')|| '未填写'}}</div>
				</div>
				<!-- 	<div class="userc">
					<span>开始工作</span>
					<div class="ucd">{{aaa|| '未选择'}}</div>
				</div> -->
				<div class="hr"></div>
				<h3 class="mt20">教育信息</h3>
				<div class="userc">
					<span>学校名称</span>
					<div class="ucd">{{userlist.school|| '未填写'}}</div>
				</div>
				<div class="userc">
					<span>入学时间</span>
					<div class="ucd">{{userlist.schoolTime.replace(',',' 至 ')|| '未选择'}}</div>
				</div>
				<div class="userc">
					<span>学历</span>
					<div class="ucd">{{userlist.education|| '未选择'}}</div>
				</div>
				<div class="hr"></div>
				<h3 class="mt20">工作信息</h3>
				<div class="userc">
					<span>公司名称</span>
					<div class="ucd">{{userlist.company|| '未填写'}}</div>
				</div>
				<div class="userc">
					<span>所属行业</span>
					<div class="ucd">{{userlist.business|| '未选择'}}</div>
				</div>
				<div class="userc">
					<span>职位名称</span>
					<div class="ucd">{{userlist.post|| '未选择'}}</div>
				</div>
				<div class="hr"></div>
				<h3 class="mt20">社交账号
					<span class="h-span">大家可以通过更多的渠道关注你</span>
				</h3>
				<div class="userc">
					<span>微信</span>
					<div class="ucd">{{userlist.weixin|| '未填写'}}</div>
				</div>
				<div class="userc">
					<span>微博</span>
					<div class="ucd">{{userlist.weibo|| '未填写'}}</div>
				</div>
				<div class="userc">
					<span>个人博客</span>
					<div class="ucd">{{userlist.blog|| '未填写'}}</div>
				</div>
				<div class="hr"></div>
				<h3 class="mt20">兴趣标签
					<span class="h-span">请您选择感兴趣的内容，五岭文化会根据您的标签帮您找到更适合您的内容。</span>
				</h3>
				<div class="userc">
					<span>感兴趣</span>
					<div class="ucd" v-if="tagArr.length == 0">
						暂无
					</div>
					<div class="ucd" v-else>
						<el-tag v-for="(item,index) in tagArr" :key="index">{{item}}</el-tag>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	// import {
	// 	compact
	// } from 'lodash'
	
	let compact = require('lodash/compact')
	export default {
		name: 'editdata',
		components: {},
		data() {
			return {
				userlist: [],
				avatar: require('@/assets/image/avatar.jpeg')
			}

		},
		computed: {
			tagArr() {
				return compact(this.userlist.tag.replace(/\s*/g, "").split(','))
			}
		},
		created() {
			this.userlist = JSON.parse(localStorage.getItem('appUser'));
		},
		methods: {
			eidtUser() {
				this.$router.push('editdatauser')
			},

		}
	}
</script>
<style lang="scss" scoped>
	.usertop {
		display: flex;
		align-items: center;

		img {
			width: 60px;
			height: 60px;
			border-radius: 100%;
			margin-right: 20px;
		}
	}

	.usercon {
		.usertitle {
			border-bottom: 1px solid var(--border);
			padding-bottom: 10px;

			.editI:hover {
				color: var(--brand);
				cursor: pointer;
			}

			.t {
				font-size: 16px;
			}

			.tips {
				margin-left: 10px;
				font-size: 14px;
			}
		}

		.userc {
			margin-top: 20px;
			display: flex;

			span {
				width: 100px;
			}

			.ucd {
				color: var(--info);
				flex: 1;

				.el-tag+.el-tag {
					margin-left: 10px;
				}

				span {
					width: auto;
				}
			}
		}
	}



	.h-span {
		font-size: 14px;
		color: var(--info);
		margin-left: 10px;
		font-weight: normal;
	}
</style>
